import convex, { waitForConvexAuthReady } from "../convexClient";
import { api } from "../convex/_generated/api";
import { useTenantStore } from "../stores/useTenantStore";

const buildTenantPath = (tenantSlug, path = "") => {
  const cleanPath = String(path || "").replace(/^\/+/, "");
  if (!tenantSlug) return cleanPath ? `/${cleanPath}` : "/";
  return cleanPath ? `/${tenantSlug}/${cleanPath}` : `/${tenantSlug}`;
};

export const getActiveTenantId = () => useTenantStore.getState().tenantId || null;
const getActiveTenantSlug = () => useTenantStore.getState().tenantSlug || null;

const requireActiveTenantId = () => {
  const tenantId = getActiveTenantId();
  if (!tenantId) {
    throw new Error("No active workspace selected.");
  }
  return tenantId;
};

export const withActiveTenant = (args = {}) => ({
  ...args,
  tenantId: requireActiveTenantId(),
});

export const buildActiveTenantPath = (path = "") =>
  buildTenantPath(getActiveTenantSlug(), path);

export const buildBudgetDetailPath = (budgetId, budgetName = budgetId) => {
  const encodedBudgetId = encodeURIComponent(String(budgetId || "").trim());
  const encodedBudgetName = encodeURIComponent(
    String(budgetName || budgetId || "").trim() || String(budgetId || "").trim()
  );

  return buildActiveTenantPath(`finance-manager/budget/${encodedBudgetId}/${encodedBudgetName}`);
};

export async function resolveDefaultTenantRoute(path = "home") {
  await waitForConvexAuthReady();
  const tenants = await convex.query(api.tenants.getUserTenants, {});
  await useTenantStore.getState().fetchUserTenants();
  if (!tenants.length) {
    return "/get-started";
  }
  return buildTenantPath(tenants[0].slug, path);
}
